import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=a5855fc0&"
var script = {}
import style0 from "./AppHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports